import { render, staticRenderFns } from "./DeleteResourceModal.vue?vue&type=template&id=6d6b99ca&"
import script from "./DeleteResourceModal.vue?vue&type=script&lang=js&"
export * from "./DeleteResourceModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteResourceModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports